import { TrafficAlertType } from 'src/app/modules/google-map/enums/google-map-enum';
import { TRAVEL_TYPE } from 'src/app/modules/maps-hotels/models/maps-hotels-model';
import { AARouterURL } from 'src/app/modules/app-routing/enums/routing.enum';

export interface ITrackingData {
  sales_journey_type?: string;

  application_channel?: string;
  application_step?: string;

  page_url?: string;
  page_title?: string;

  payment_frequency?: string;
  payment_type?: string;
  product_name?: string;
  product_quantity?: number;

  site_section: string;
}

export interface IRoutePlannerModel {
  apiBaseUrl: string;
  siteBaseUrl: string;
  enableDebug: boolean;

  sitecoreApiBaseUrl: string;
  sitecoreheadlessUrl: string;
  sitecoreXMheadlessUrl: string;
  itemId: string;
  apiKey: string;

  traffic: string;
  parking: string;
  rangeSet: string;

  googleKey: string;
  unleash?: IUnleashEnvironmentProvider;
  unleashToken: string;
  utagUrl: string;
  oneTrustUrl: string;
  googleAdUrl: string;
  oneTrustDataDomain: string;
}
export interface IUnleashEnvironmentProvider {
  url: string;
  appName: string;
  environment: string;
}
export interface IBoundingBoxModel {
  bottom: number;
  left: number;
  right: number;
  top: number;
}
export interface ITrafficAlertCarkPark {
  geoHash: string;
  hitCount: number;
  lat: number;
  lon: number;
  topHits: ITrafficAlertsTopHits[] | CarParkTopHits[];
}

export interface ITrafficAlertsTopHits {
  delayDistance: number;
  delayFromFreeFlowMinutes: number;
  delayFromTypicalMinutes: number;
  description: string;
  direction: string;
  endTime: string;
  eventCode: string;
  eventText: string;
  id: string;
  impacting: boolean;
  lat: number;
  lon: number;
  roadName: string;
  severity: string;
  startTime: string;
  type: string;
  aaIncidentType: TrafficAlertType;
}

export interface IServiceTopHits {
  delayDistance: number;
  delayFromFreeFlowMinutes: number;
  delayFromTypicalMinutes: number;
  description: string;
  direction: string;
  endTime: string;
  eventCode: string;
  eventText: string;
  id: string;
  impacting: boolean;
  lat: number;
  lon: number;
  roadName: string;
  severity: string;
  startTime: string;
  type: string;
  aaIncidentType: TrafficAlertType;
  categoryId: TRAVEL_TYPE;
  operator: string;
  googleParkingAddress: IParkingAddress;
  name: string;
  address: any;
}

export interface ITravelTopHits {
  delayDistance: number;
  delayFromFreeFlowMinutes: number;
  delayFromTypicalMinutes: number;
  description: string;
  direction: string;
  endTime: string;
  eventCode: string;
  eventText: string;
  id: string;
  impacting: boolean;
  lat: number;
  lon: number;
  roadName: string;
  severity: string;
  startTime: string;
  type: string;
  aaIncidentType: TrafficAlertType;
  categoryId: TRAVEL_TYPE;
  operator: string;
  googleParkingAddress: IParkingAddress;
  name: string;
}

export interface ITrafficAlertsTopHits {
  delayDistance: number;
  delayFromFreeFlowMinutes: number;
  delayFromTypicalMinutes: number;
  description: string;
  direction: string;
  endTime: string;
  eventCode: string;
  eventText: string;
  id: string;
  impacting: boolean;
  lat: number;
  lon: number;
  roadName: string;
  severity: string;
  startTime: string;
  type: string;
  aaIncidentType: TrafficAlertType;
}

export class CarParkTopHits {
  availableSpaces: number;
  cctv: boolean;
  disabledSpaces: number;
  height: number;
  id: string;
  lat: number;
  lon: number;
  light: boolean;
  operator: string;
  parkingAddress: IParkingAddress;
  googleParkingAddress: IParkingAddress;
  payment: string;
  phone: string;
  surface: string;
  url: string;

  get latLng() {
    return new google.maps.LatLng(this.lat, this.lon);
  }
}

export interface IParkingAddress {
  addressLineOne: string;
  city: string;
  country: string;
  postcode: string;
  street: string;
}
export interface ICarLink {
  apiCarLinkBaseUrl: string;
}

// Mobile
export interface IMobileNavigationEventModel {
  ActivePage: AARouterURL;
  ActiveTab: AARouterURL;
}

export class MobileMenuModel {
  toggleMenu = true;
  searchActive = true;
  mapActive = false;

  // Keep track of scroll y position
  scrollYPosition = 0;

  public toggleMenus(): void {
    this.toggleMenu = !this.toggleMenu;
  }

  public setActiveMenu(tabName: AARouterURL): void {
    if (tabName === AARouterURL.MOBILE_MAP) {
      this.searchActive = false;
      this.mapActive = true;
    } else {
      this.searchActive = true;
      this.mapActive = false;
    }
    this.toggleMenu = true;
  }
}



export type TcfEventStatus = 'tcloaded' | 'cmpuishown' | 'useractioncomplete';

export interface ITcData {
  eventStatus: TcfEventStatus;
  purpose?: { consents?: { [purposeId: number]: boolean } };
  vendor?: { consents?: { [vendorId: number]: boolean } };
  listenerId?: number;
}

type TcfCallback = (tcData: ITcData, success: boolean) => void;

export interface ITcfApi {
  (command: 'addEventListener', version: 2, callback: TcfCallback): void;
  (command: 'getTCData', version: 2, callback: TcfCallback): void;
  (command: 'removeEventListener', version: 2, callback: (ok: boolean) => void, listenerId: number): void;
}